<template>
    <div>
        <Banner :displayHomeButton="true"></Banner>
        <v-row justify="center" no-gutters>
            <v-col cols="9">
                <v-row justify="center" no-gutters>
                    <div class="reference-type">{{this.line1.toUpperCase()}}</div>
                </v-row>
                <v-row v-if="reference" justify="center" no-gutters>
                    <div class="applicant">{{this.line2.toUpperCase()}}</div>
                </v-row>
                <div v-if="reference">
                    <router-view v-if="!submitted"></router-view>
                    <v-row v-else no-gutters>
                        <div class="greeting-message">
                        Thank you for taking the time to submit {{this.referenceInline}} for {{this.reference['GO_Scholar__c.Name']}}’s GO Scholarship application. We may be in touch for further information, if required. <br><br>
                        {{this.reference['GO_Scholar__c.Name']}} will find out if they are successful at the end of November. Until then, we will not be able to give an update on their application.<br><br>
                        Thank you from everyone at GO!
                        </div>               
                    </v-row>
                </div>
                <div v-if="notFound">
                    <v-row no-gutters style="margin-top: 40px">
                        <div class="greeting-message">
                            Thank you for attempting to provide a reference for a student application to the GO Foundation.<br><br>
                            The page you have attempted to access is incorrect. Please check the link provided in the email you received or click on the Support button below to request assistance.
                        </div>               
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <div style="height: 100px"></div>
    </div>

</template>
<script>
import Banner from './BannerComponent';

const TYPE_MAPPING = {
    undefined:'',
    'Primary Guardian': 'guardian',
    'School Referee': 'school',
    'Community Referee': 'community'
}

const TEXT_CONVERT = {
    undefined: '',
    'School Referee': 'school reference',
    'Community Referee': 'community reference',
    'Primary Guardian': 'primary guardian declaration' 
}

const SUBMISSION_MAPPING = {
        undefined: '',
        'Primary Guardian': 'declaration submitted',
        'School Referee': 'reference submitted',
        'Community Referee': 'reference submitted'
}

const THANKYOU_MAPPING = {
        'Primary Guardian': 'your endorsement and declaration',
        'School Referee': 'a reference',
        'Community Referee': 'a reference'
}

export default {
    components:{
        Banner
    },

    async beforeMount() {
        console.log('reference beforemount');
        console.log(this.$route.params.reference_id);
        await this.$store.dispatch('reference/fetchReference',{refId: this.$route.params.reference_id})
        if(this.$store.getters['reference/referenceStatus'] == 200 && this.$store.getters['reference/scholarshipStatus'] == 200){

            this.reference = this.$store.getters['reference/reference'];
            this.scholarship = this.$store.getters['reference/scholarship'];
            this.submitted = this.reference['Feedback_Submitted__c'];
            this.scholarship['Description__c'] = this.scholarship['Description_for_references__c']
            console.log('print reference and scholarship');
            console.log(this.reference);
            console.log(this.scholarship);
            if(this.reference.scholarship_level__c == 'Primary'){
                this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'primary'});
            }else if(this.reference.scholarship_level__c == 'Secondary'){
                this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'high'});
            }else if(this.reference.scholarship_level__c == 'Tertiary'){
                this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'uni'});
            }
        }else{
            this.notFound = true
        }
    },
    data: function() {
        return {
            reference: undefined,
            scholarship: undefined,
            submitted: false,
            notFound: false
        }
    },
    computed:{
        line1(){
            if(this.notFound){
                return 'REFERENCE'
            }
            if(!this.reference){
                return 'Preparing the reference questions...'
            }
            return this.submitted? SUBMISSION_MAPPING[this.reference['Type__c']] : TEXT_CONVERT[this.reference['Type__c']]  
        },

        line2(){
            if(!this.reference){
                return ''
            }            
            return this.submitted ? 'THANK YOU!' : `APPLICANT: ${this.reference['GO_Scholar__c.Name']}`
        },
        referenceInline() {
            return THANKYOU_MAPPING[this.reference['Type__c']]
        },
        type(){
            return TYPE_MAPPING[this.reference['Type__c']]
        },
        /**Reference Validation Rules */
        isRequired() {
            return [
                v => !!v || 'The field cannot be empty'
            ]
        },
        isName() {
            return [
                v => !!v || 'The field cannot be empty',
                // v => /^[A-Z][A-Za-z-']*$/.test(v) || 'Please enter a valid name'
            ]
        },
        isPhoneNumber() {
            return [
                v => !!v || 'Phone number is required',
                v => /0[0-9]{9}/.test(v) || 'Please enter a valid phone number'
                //v => /0[23478][0-9]{8}/.test(v) || 'Please enter a valid phone number'
            ]
        },
        isEmail() {
            return [
                v => !!v || 'Email is required',
                v => /.+@.+\..+/.test(v) || 'Email must be valid'
            ]
        },
        notEmpty() {
            return [v => Boolean(v) && String(v).trim().length > 0]
        }
    },
    methods: {
        async saveReference(){

            return await this.$store.dispatch('reference/saveReference',  {payload: this.reference})
            
        }        
    }
}
</script>
<style lang="scss" scoped>
.greeting-message
{
  width: 940px;
  font-family: Hind;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: black;
  margin: auto;
}

.reference-type {
  width: 600px;
  font-family: Dosis;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 4px;
  text-align: center;
  color: black;
  margin-top: 40px;
}

.applicant{

    @extend .reference-type;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 3.2px;
    height: 31px;
    margin-top: 20px;
    margin-bottom: 40px;

}

.bold {
    font-weight: bold;
}
</style>